document.addEventListener('DOMContentLoaded', function() {
    const detailBoxes = document.querySelectorAll('.easy-faq-double-detail-box');

    if (detailBoxes.length >= 2 && window.ShopifyLocalization) {
        // Email box
        const emailBox = detailBoxes[0];
        const emailElement = emailBox.querySelector('.easy-faq-single-detail-box-details p:last-child');
        if (emailElement && window.ShopifyLocalization.email) {
            emailElement.innerHTML = `<a href="mailto:${window.ShopifyLocalization.email}" style="color:#000000">${window.ShopifyLocalization.email}</a>`;
        }

        // Phone box
        const phoneBox = detailBoxes[1];
        const phoneElement = phoneBox.querySelector('.easy-faq-single-detail-box-details p:last-child');
        if (phoneElement && window.ShopifyLocalization.phone) {
            phoneElement.textContent = window.ShopifyLocalization.phone;
        }
    }

    const introTextElement = document.querySelector('.introTextFaqPlus p');

    if (introTextElement && window.ShopifyLocalization.openingHoursNotice) {
        introTextElement.textContent = window.ShopifyLocalization.openingHoursNotice;
    }
});
